export default "__VITE_ASSET__CZmuc7$K__"